import(/* webpackMode: "eager", webpackExports: ["Blocks","BuilderContext","Button","Columns","Content","Fragment","Image","Section","Symbol","Text","Video"] */ "/app/node_modules/@builder.io/sdk-react/lib/node/blocks-exports.mjs");
;
import(/* webpackMode: "eager" */ "/app/src/libs/builder/Content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/app/src/libs/i18n/Link.tsx");
